import React from 'react'
import { useParams } from 'react-router-dom';

export type TopTab = 'gallery' | 'about' | 'communication' | 'sharing';

interface IDetailsHeaderTabs {
    topTab: TopTab;
    setTopTab: (value: TopTab) => void;
}

const DetailsHeaderTabs = ({ setTopTab, topTab, }: IDetailsHeaderTabs) => {

    const params = useParams();
    const vaultType = params?.type || '';

    return (
        <div className="ld-header__tabs">
            <button
                className={`ld-top-tab${topTab === 'gallery' ? ' ld-top-tab--active' : ''}`}
                onClick={() => setTopTab('gallery')}
            >
                <img src={topTab === 'gallery' ? '/assets/images/grid-active.svg' : "/assets/images/gallery-icon.svg"} alt="" className="ld-top-tab__icon" />
                Gallery
            </button>
            <button
                className={`ld-top-tab${topTab === 'about' ? ' ld-top-tab--active' : ''}`}
                onClick={() => setTopTab('about')}
            >
                <img src={topTab == 'about' ? "/assets/images/about-icon.svg" : "/assets/images/about-inactive.svg"} alt="" className="ld-top-tab__icon" />
                About
            </button>
            {vaultType == 'myvault'
                ?
                null
                :
                <button
                    className={`ld-top-tab${topTab === 'communication' ? ' ld-top-tab--active' : ''}`}
                    onClick={() => setTopTab('communication')}
                >
                    <img src="/assets/images/communication-icon.svg" alt="" className="ld-top-tab__icon" />
                    Communication
                </button>
            }
            {vaultType == 'myvault'
                ?
                null
                :
                <button
                    className={`ld-top-tab${topTab === 'sharing' ? ' ld-top-tab--active' : ''}`}
                    onClick={() => setTopTab('sharing')}
                >
                    <img src={topTab === 'sharing' ? '/assets/images/sharing-active-icon.svg' : "/assets/images/sharing-icon.svg"} alt="" className="ld-top-tab__icon" />
                    Sharing
                </button>
            }
        </div>
    )
}

export default DetailsHeaderTabs